<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">Cash/Bank Transaction List 
        <div class="card-header-actions">
          <b-dropdown text="Add" variant="primary mr-1" >
            <b-dropdown-item @click="addPayment" >New Payment</b-dropdown-item>
            <b-dropdown-item @click="addReceipt" >New Receipt</b-dropdown-item>
          </b-dropdown>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="voidConfirm" :disabled="((model.isvoid==1) || (model.poststatus==0))">Void</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-dropdown text="Posting" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="(model.poststatus == 1)">Posting</b-dropdown-item>
            <b-dropdown-item @click="posting" :disabled="(model.poststatus == 0)">Un Posting</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Form</b-dropdown-item>
            <b-dropdown-item @click="printjv" >JV</b-dropdown-item>
            <b-dropdown-item @click="printkwitansi" :disabled="(model.valas_out != 0)">Kwitansi</b-dropdown-item>
          </b-dropdown>
          <!-- <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print JV
          </button> -->
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="tblData.uraian" style="width:25% !important;"></b-form-input>
            <b-input-group-prepend><span class="p-1">To/From</span></b-input-group-prepend>
            <b-form-input v-model="tblData.terimadari" placeholder="Pay to/Receipt from"></b-form-input>
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
            <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
            <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
            <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" style="width:28% !important"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" style="width:28% !important"></b-form-input>
            <b-form-select v-model="tblData.poststatus" :plain="true" class="ml-1" :options="postingStatus"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="5">
                <b-input-group >
                  <b-input-group-prepend><label>Trx. Number</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.nomor" placeholder="nomor (% for wildcard)"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col  lg="7">
                <b-input-group >
                  <b-input-group-prepend><span class="pt-2">Cheque/Giro# &nbsp;</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.paymethod" placeholder="Payment Method"></b-form-input>
                </b-input-group>
            </b-col>
          </b-row>              
            <b-input-group >
              <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
              <b-form-input v-model="tblData.namaacc" @change="tblData.kodebank=''" placeholder="Finance Bank Code"></b-form-input>
              <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow=true">
                      <i class="fa fa-search"></i>
                  </b-btn>
              </b-input-group-append>
              <b-form-input v-model="tblData.kodeacc" placeholder="Accounting Code" class="ml-1"></b-form-input>
            </b-input-group>                  
          <b-input-group >
            <b-input-group-prepend><label >Pay/Receipt Group</label></b-input-group-prepend>
              <b-form-select v-model="tblData.trxgroup" :plain="true" :options="trxgroups" style="width:25% !important;"></b-form-select>
              <b-form-select v-model="tblData.iogroup" :plain="true" :options="['','All Payment','All Receipt']" class="ml-1"></b-form-select>
            
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label >Input By</label></b-input-group-prepend>
            <b-form-input v-model="tblData.createby"  placeholder="Type username"></b-form-input>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
          @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"><span v-if="(data.item.poststatus==1)">View</span><span v-else>Edit</span> </b-dropdown-item>
          <b-dropdown-item @click="rowVoid(data.item)" href="#" :disabled="((data.item.isvoid==1) || (data.item.poststatus==0))">Void</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="(data.item.poststatus==0)">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="(data.item.poststatus==1)">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" >Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowPrintJv(data.item)" href="#" >Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowPrintkwitansi(data.item)" href="#" :disabled="(data.item.valas_out!=0)">Print Kwitansi</b-dropdown-item>
          <b-dropdown-item @click="rowEmail(data.item)" href="#" v-if="((data.item.trxgroups || '').includes('AP Paym'))">Email to Vendor</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.poststatus==1)"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>          
        <template v-slot:cell(nomor)="data">
          <div v-if="data.item.poststatus==0" style="background-color:yellow;">{{data.item.nomor}}</div>
          <div v-else>{{data.item.nomor}}</div>
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(original)="data">
          <span v-if="data.item.poststatus==0" style="background-color:yellow;">           
            {{(data.item.valas_in+data.item.valas_out)|numFormat}}
          </span>
          <span v-else> 
            {{(data.item.valas_in+data.item.valas_out)|numFormat}}
          </span>
        </template>
        <template v-slot:cell(bank_in)="data">
          {{data.item.bank_in|numFormat}}
        </template>
        <template v-slot:cell(bank_out)="data">
          {{data.item.bank_out|numFormat}}
        </template>
      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>        
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
      <b-modal v-model="showVoidConfirm" title="Void Transcation?" :centered="true" @ok="voidData">
        <p class="mb-1">1 record is about to be Void/Canceled/Reversed</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
        <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData"></lku-bankaccount>
    </b-modal>        

  </div>
</template>

<style lang="scss">
    .list-of-tranbank {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
import tranbank from "../../apis/tranbank";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import { validationMixin } from "vuelidate";
import { email } from "vuelidate/lib/validators";
toastr.init();

export default {   
 components: {Loading,lkuBankaccount},
  mixins: [validationMixin],
  validations: {
        vendorEmail: {
            recepient: { email }
        },
  }, 
  data() {
    return {
      uanguser:this.$store.state.user.matauang,
      showFilter: false,
      showDelConfirm: false,
      showVoidConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
        lkuBankaccountData:{},
      lkuBankaccountShow: false,
      isLoading:false,
      showReport:false,
      isprintjv: false,
      reportUrl: null,
      model:{},
      vendorEmail:{recepient:''},
      pagination: false,
      limit:20,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        tgl2: moment().format('YYYY-MM-DD'),
        sortBy: 'tanggal',
        sortDesc: true,DimCol:'', 
        iogroup:'', trxgroup:'',createby:''
      },
      postingStatus:[{ value: '1', text: 'Posted'}, { value: '0', text: 'Not Posted'},{ value: '', text: '-- All --'}],
      trxgroups : [{ value: '', text: '--- All ---'},
        { value: 'AR Payment', text: 'AR Payment Receipt' },
        { value: 'Sales PrePayment', text: 'Sales PrePayment Receipt' },
        { value: 'Adv.Settlement-Return', text: 'Adv.Settlement-Excess Cash' },
        { value: 'AP Payment', text: 'AP Payment' },
        { value: 'Cash Advance Payment', text: 'Cash Advance Payment' },
        { value: 'Adv.Settlement-Addition', text: 'Adv.Settlement-Excess Expense' },
        { value: 'Expense Reimburs', text: 'Expense Reimbursment Payment' },
        { value: 'Transfer Inter Account', text: 'Transfer Inter Account' },
        { value: 'Other Receipt', text: 'Other Receipt' },
        { value: 'Other Payment', text: 'Other Payment' } 
      ]     
    };
  },
computed: {
  dimension(){
    return this.$store.state.dimension;
  },
  dimCol() {
      return this.tblData.DimCol;
  },
  tblFields(){
    const fields=[
        {
          key: "action",
          label: "Action",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "nomor",
          label: "Trx. Number",
          sortable: true
        },
        {
          key: "namabank",
          label: "Cash/Bank Name",
          sortable: true
        },
        {
          key: "kodeacc",
          label: "Acc. Code",
          thStyle: "width:50px",
          sortable: true
        },
        {
          key: "tanggal",
          thStyle: "width:70px",
          label: "Trx. Date",
          sortable: true
        },
        {
          key: "uraian",
          label: "Description",
          sortable: true
        },
        {
          key: "terimadari",
          label: "to/from",
          sortable: true
        },
        {
          key: "paymethod",
          label: "Pay Method",
          sortable: true
        },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
        {
          key: "original",
          label: "Original Amt.",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "bank_in",
          label: `Debit (${this.uanguser})` ,
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
            sortable: true
        },
        {
          key: "bank_out",
          label: `Credit (${this.uanguser})`,
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
            sortable: true
        },
        {
          key: "createby",
          label: "Input By",
          thStyle: "width:80px",
          sortable: true
        },

      ];
      const dims = this.$store.state.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        fields.push(          {
          key: `${dims[i].value}Txt`,
          // thStyle: "width:100px",
          label: dims[i].text,
            sortable: true
        },)
      }

    return fields;
  },
  invalidEmail() {
    this.$v.vendorEmail.$touch();
    return this.$v.vendorEmail.$invalid;
  },

},
watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    "tblData.iogroup": function(newval) {
      if (newval) {
        this.tblData.trxgroup="";
      }
    },
    "tblData.trxgroup": function(newval) {
      if (newval) {
        this.tblData.iogroup="";
      }
    }
  },  
  methods: {
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowVoid(record) {
      this.model = record;
      this.voidConfirm();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintJv(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowPrintkwitansi(record) {
      this.rowClicked(record);
        this.printkwitansi();        
    },
    rowVoid(record) {
      this.rowClicked(record);
        this.voidConfirm();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    async rowEmail(record) {
      this.rowClicked(record);
      toastr.info('Email Payment confoirmation to vendor/Supplier ');
          try {
              const data = await tranbank.paymentdetail({id:record.trbankkey });
              const appayments = data[1];
                // console.log('appayments: ', appayments);
              for (let index = 0; index < appayments.length; index++) {
                const apinv = appayments[index];
                const hasilcheck = await tranbank.emailCheck({idVendor:apinv.vendor_id});
                // console.log('hasilcheck: ', hasilcheck);
                if (hasilcheck.contact_email){
                    const arrEmail=hasilcheck.contact_email.split(',');
                    let allValid=true;
                    for (let index = 0; index < arrEmail.length; index++) {
                        this.vendorEmail.recepient=arrEmail[index];
                        if (this.invalidEmail) {
                              allValid=false;
                              toastr.error('Invalid Email Address.', "Mailing Error");
                        }
                    }
                    if (allValid==true) {
                      console.log('hasilcheck.contact_email: ', hasilcheck.contact_email);
                      apinv.contact_email = hasilcheck.contact_email;
                      await tranbank.emailVendor(apinv);
                    } else {
                      toastr.warn('Please Edit Vendor Contact/EMAIL, before Sending Email');
                    }
                  this.isLoading=false;
                } else {
                  this.isLoading=false;
                      toastr.warn('Please Edit Vendor Contact/EMAIL, before Sending Email');
                }
                
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }

    },    
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.tblData.kodebank=lkuData.selected.kode;
        this.tblData.matauang=lkuData.selected.matauang;
        this.tblData.namaacc=lkuData.selected.namabank;
        this.tblData.nomorrek=lkuData.selected.nomorrek;
        this.lkuBankaccountShow=false;
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'terimadari', 'kodeacc', 'namaacc', 'kodebank', 'paymethod', 'trxgroup', 'iogroup', 'poststatus'];
      let filtered = false;
      const trBanklist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              trBanklist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          trBanklist.page=this.tblData.page;
          trBanklist.limit=this.tblData.limit;
          trBanklist.sortBy=this.tblData.sortBy;
          trBanklist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.trBanklist=trBanklist;
          this.$store.commit("filter", filter);
      } 
    },    
    addPayment(){
      this.saveFilter();
      router.push("payment");
    },
    addReceipt(){
      this.saveFilter();
      router.push("receipt");
    },
    edit: function() {
        if (this.model.trbankkey) {
          this.saveFilter();
          if (this.model.valas_in===0){
              if (this.model.isvoid==1) {
                router.push(`void-payment/${this.model.trbankkey}`);
              } else {
                router.push(`payment/${this.model.trbankkey}`);
              }
          } else
          {
              if (this.model.isvoid==1) {
                router.push(`void-receipt/${this.model.trbankkey}`);
              } else {
                router.push(`receipt/${this.model.trbankkey}`);
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    editjv: function() {
        if (this.model.trbankkey) {
            this.saveFilter();
            const tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
          // router.push({name :'treasury.editjvfrm', params: { nomor: this.model.nomor, tanggal, kodejurnal:'APINV', fsubkode2:'ap_invoice_tt',kodefield2:'apinvkey',subkode2: this.model.apinvkey}});
          router.push({name :'treasury.editjvfrm', params: { nomor: this.model.nomor, tanggal: this.model.tanggal}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },    
    deleteConfirm() {
        if (this.model.trbankkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await tranbank.remove(this.model);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
          this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    voidConfirm() {
        if (this.model.trbankkey) {
          this.showVoidConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Voided!');
        }
    },
    voidData: async function() {
        if (this.model.trbankkey) {
          this.saveFilter();
          if (this.model.valas_in===0){
              router.push(`void-payment/${this.model.trbankkey}`);
          } else
          {
              router.push(`void-receipt/${this.model.trbankkey}`);
          }
        } else {
            toastr.warn('Please select a row that want to be Voided!');
        }
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.trBanklist) {
            this.tblData[key] = filter.trBanklist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.trBanklist.tgl1 || '';
          this.tblData.tgl2=filter.trBanklist.tgl2 || '';

          this.showFilter=filtered;
          delete filter.trBanklist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await tranbank.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await tranbank.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }


    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodebank= '';
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.terimadari=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.createby=  '';
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.trbankkey) {
            if ((this.model.poststatus || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.poststatus == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            if (this.model.bank_out != 0) {
              await tranbank.postingPayment(this.model);
            } else {
              await tranbank.postingReceipt(this.model);
            }
            this.model.poststatus=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await tranbank.postingUndo(this.model);
            this.model.poststatus=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model.trbankkey) {
          try {
                this.showReport=true;
              this.reportUrl= await tranbank.print(this.model);
              this.isprintjv=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printjv: async function()
    {
      if (this.model.trbankkey) {
          try {
              if ((this.model.poststatus || 0) == 0) {
                if (this.model.bank_out != 0) {
                  await tranbank.postingPayment(this.model);
                } else {
                  await tranbank.postingReceipt(this.model);
                }
                this.model.poststatus=1;
              }
              this.showReport=true;
              this.reportUrl= await tranbank.printjv(this.model);
              this.isprintjv=true;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printkwitansi: async function()
    {
      if (this.model.trbankkey) {
          try {
                if (this.model.valas_in != 0) {
                  this.reportUrl= await tranbank.printkwitansi(this.model);
                  this.isprintjv=false;
                  if (this.$isMobile()){
                      window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
                  } else {
                    this.showReport=true;
                  }
                }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await tranbank.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    close(){
      router.push("/treasury/home");
    },    
  }
};
</script>
